export const infrastructure = [
  {
    name: 'Ubuntu',
    imgUrl: '/technologies/os/ubuntu.png'
  },
  {
    name: 'Git',
    imgUrl: '/technologies/git.png'
  },
  {
    name: 'Azure DevOps',
    imgUrl: '/technologies/azure.svg'
  },
  {
    name: 'Gitlab',
    imgUrl: '/technologies/gitlab.svg'
  },
  {
    name: 'Github',
    imgUrl: '/technologies/github.svg'
  },
  {
    name: 'Docker',
    imgUrl: '/technologies/docker.svg'
  }
];
